module.exports = __webpack_public_path__ + "img/social-fb.348a4823.png";